import CoinDetails from 'src/pages/CoinDetails'
import { wrapper } from 'src/redux/store'
import {
  getCoinData,
  getLineNews,
  getCoinDetailTabData, // Import this if required
} from 'src/redux/thunks'
import { API_ENDPOINT } from 'src/consts/env'

const Coin = CoinDetails

export const getServerSideProps = wrapper.getServerSideProps(
  store =>
    async ({ params, res }) => {
      const slug = params.slug

      // Fetch the basic coin data
      await store.dispatch(getCoinData({ url: API_ENDPOINT, slug }))

      // Fetch related data for tabs
      await Promise.all([
        store.dispatch(getLineNews(API_ENDPOINT)),
        store.dispatch(
          getCoinDetailTabData({ url: API_ENDPOINT, tab: 'chart', slug })
        ),
        store.dispatch(
          getCoinDetailTabData({ url: API_ENDPOINT, tab: 'markets', slug })
        ),
        store.dispatch(
          getCoinDetailTabData({ url: API_ENDPOINT, tab: 'news', slug })
        ),
        store.dispatch(
          getCoinDetailTabData({ url: API_ENDPOINT, tab: 'widgets', slug })
        ),
        store.dispatch(
          getCoinDetailTabData({ url: API_ENDPOINT, tab: 'swap', slug })
        ),
      ])

      res.setHeader('Cache-Control', 'public, s-maxage=5')
    }
)

export default Coin
